<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h3 class="text-center">{{ $t('creditDebitReport.title') }}</h3>
      <p class="text-center mb-3 no-print">
        {{ $t('creditDebitReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && data" class="row">
      <div class="col-6">
        <card :title="$t('creditDebitReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('creditDebitReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ data.generated_at | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('creditDebitReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ data.from | dateOnly }} - {{
                  data.to | dateOnly
                }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t(`creditDebitReport.summary.totalCredits`) }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ totalCredits | money }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="data" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`creditDebitReport.topUpsRefundTableLabel`) }}<small
            class="ml-2 text-muted">({{ data.from | dateOnly }} - {{ data.to | dateOnly }})</small>
          </h4>
          <table class="table table-report">
            <tr>
              <td>{{ $t(`creditDebitReport.results.topUpPaymentCardLabel`) }}</td>
              <td>{{ data.top_ups_by_cards_sum | money }}</td>
            </tr>
            <tr>
              <td>{{ $t(`creditDebitReport.results.topUpBankLinkLabel`) }}</td>
              <td>{{ data.top_ups_by_bank_link_sum | money }}</td>
            </tr>
            <tr>
              <td>
                {{ $t(`creditDebitReport.results.refundedToBankAccountLabel`) }}
              </td>
              <td>
                {{ data.refunded_to_bank_account_sum | money }}
              </td>
            </tr>
          </table>
        </card>
      </div>
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`creditDebitReport.distributorsTableLabel`) }}<small
            class="ml-2 text-muted">({{ data.from | dateOnly }} - {{ data.to | dateOnly }})</small>
          </h4>
          <table class="table table-report">
            <tr>
              <td>{{ $t(`creditDebitReport.results.topUpDistributorLabel`) }}</td>
              <td>{{ data.top_ups_by_distributors_sum | money }}</td>
            </tr>
            <tr>
              <td>{{ $t(`creditDebitReport.results.seasonTicketsPriceSum`) }}</td>
              <td>{{ data.season_ticket_prices_sum | money }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td>
                {{ $t(`creditDebitReport.results.totalLabel`) }}
              </td>
              <td>
                {{ distributorTotals | money }}
              </td>
            </tr>
          </table>
        </card>
      </div>
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`creditDebitReport.seasonTicketRefundsTableLabel`) }}<small
            class="ml-2 text-muted">({{ data.from | dateOnly }} - {{ data.to | dateOnly }})</small>
          </h4>
          <table class="table table-report">
            <tr>
              <td>{{ $t(`creditDebitReport.results.refundedToSystemAccountLabel`) }}</td>
              <td>{{ data.refunded_season_tickets_sum | money }}</td>
            </tr>
          </table>
        </card>
      </div>
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`creditDebitReport.emvClearedTableLabel`) }}<small
            class="ml-2 text-muted">({{ data.from | dateOnly }} - {{ data.to | dateOnly }})</small>
          </h4>
          <table class="table table-report">
            <tr>
              <td>{{ $t(`creditDebitReport.results.emvClearedLabel`) }}</td>
              <td>{{ data.emv_cleared_sum | money }}</td>
            </tr>
          </table>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {BaseAlert} from 'src/components';
import ReportFilter from "./ReportFilter";

export default {
  name: 'credit-debit-report',
  components: {
    BaseAlert,
    ReportFilter
  },
  computed: {
    ...mapState({
      loading: state => state.credit_debit_report.loading,
      data: state => state.credit_debit_report.data,
      error: state => state.credit_debit_report.error,
    }),
    totalCredits() {
      return this.data.top_ups_by_cards_sum + this.data.top_ups_by_bank_link_sum + this.data.top_ups_by_distributors_sum + this.data.refunded_season_tickets_sum + this.data.emv_cleared_sum ;
    },
    distributorTotals() {
      return this.data.top_ups_by_distributors_sum + this.data.season_ticket_prices_sum;
    }
  },
  methods: {
    ...mapActions(['GetCreditDebitReport']),
    reloadReport(query) {
      this.GetCreditDebitReport(query);
    },
  }
};
</script>

